import Stat from '@/service/stat'
import RequestUtils from './requestUtils.js'

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getproductstats(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Stat.getproductstats(payload), {
        type: 'info',
        success,
        fail
      })
    },
    getscantagstats(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Stat.getscantagstats(payload), {
        type: 'info',
        success,
        fail
      })
    },
    getinventorys(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Stat.getinventorys(payload), {
        type: 'info',
        success,
        fail
      })
    },
    suminventoryinout(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Stat.suminventoryinout(payload), {
        type: 'info',
        success,
        fail
      })
    },
    getinventoryinouttrend(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Stat.getinventoryinouttrend(payload), {
        type: 'info',
        success,
        fail
      })
    },
    sumstocksafety(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Stat.sumstocksafety(payload), {
        type: 'info',
        success,
        fail
      })
    },
    sumordertrend(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Stat.sumordertrend(payload), {
        type: 'info',
        success,
        fail
      })
    },
    sumproducttrading(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Stat.sumproducttrading(payload), {
        type: 'info',
        success,
        fail
      })
    },
    sumcustomertrading(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Stat.sumcustomertrading(payload), {
        type: 'info',
        success,
        fail
      })
    }
  }
}
